export const getApplicantsAge = (dateString, dates) => {
  // const earliestDate = new Date("March 31, 2024");
  let earliestDate;
  if (dates?.endDate) {
    earliestDate = new Date(dates?.endDate);
  }

  if (!earliestDate) {
    earliestDate = getGrantEndDate();
  }

  const birthDate = new Date(dateString);
  const m = earliestDate.getMonth() - birthDate.getMonth();
  let age = earliestDate.getFullYear() - birthDate.getFullYear();
  if (m < 0 || (m === 0 && earliestDate.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const getOtherPersonAge = (dateString, dates) => {
  // const earliestDate = new Date("March 31, 2024");
  let earliestDate;
  if (dates?.endDate) {
    earliestDate = new Date(dates?.endDate);
  } else {
    console.log("End date not found");
    earliestDate = getGrantEndDate();
  }

  const birthDate = new Date(dateString);
  const m = earliestDate.getMonth() - birthDate.getMonth();
  let age = earliestDate.getFullYear() - birthDate.getFullYear();
  if (m < 0 || (m === 0 && earliestDate.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export function isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

export function getGrantEndYear() {
  const date = new Date();
  if (date.getMonth() < 3) {
    return date.getFullYear();
  } else {
    return date.getFullYear() + 1;
  }
}

export function getGrantEndDate() {
  return new Date(`March 31, ${getGrantEndYear()}`);
}

export function canHaveFrenchSuperscript(date) {
  if (typeof date === "string") {
    const dateParts = date.split(" ");
    if (dateParts[0] === 1) {
      return true;
    }
  }
  return false;
}

const getHumanReadableMonth = (month) => {
  switch (month) {
    case 0:
      return "January";
    case 1:
      return "February";
    case 2:
      return "March";
    case 3:
      return "April";
    case 4:
      return "May";
    case 5:
      return "June";
    case 6:
      return "July";
    case 7:
      return "August";
    case 8:
      return "September";
    case 9:
      return "October";
    case 10:
      return "November";
    case 11:
      return "December";
    default:
      return "";
  }
};

export const humanReadableDate = (date) => {
  let dateObj = new Date(date);

  return `${dateObj.getDate()} ${getHumanReadableMonth(
    dateObj.getMonth()
  )} ${dateObj.getFullYear()}`;
};

export function getYearFromDate(date) {
  if (!date) {
    return null;
  }
  return new Date(date).getFullYear();
}
